export default {
    modal: {
        approve: 'Approve',
        reject: 'Reject',
        cancel: 'Cancel',
        annul: 'Cancel',
        comment: 'Comment',
        close_all_modals: 'Close all modal windows?',
        close_yes: 'Yes',
        close_no: 'No',
        enable_push: 'Enable push notifications in browser?',
        enable: 'Enable',
        deny: 'Cancel',
        close_all: 'close all',
        opened: 'Opened modals',
        logoutQuestion: 'You are authentificated, but for registration you have to log out',
        cancelModal: 'Cancel'
    }
};
